// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rtzA","controls":"styles_controls__1dNkg","charLimit":"styles_charLimit__Fllce","input":"styles_input__2XvfU","send":"styles_send__3XXJT"};